import React from 'react';
import { Table } from 'antd';
import colors from '../../share/constants/constants';

const DynamicTable = ({ columns, data, scroll, loading }) => {
  const customHeaderStyle = {
    backgroundColor: colors.lightLavender,
    color: colors.primaryPurple,
  };

  const modifiedColumns = columns.map((col) => ({
    ...col,
    onHeaderCell: (column) => ({
      style: customHeaderStyle,
    }),
  }));

  return (
    <div className="container p-2">
      <Table
        columns={modifiedColumns}
        dataSource={data}
        loading={loading}
        pagination={false}
        scroll={{ x: "100%" }}
        className="shadow-md rounded-md"
        rowClassName='custom-row'
        headerBorderRadius={8}
      />
    </div>
  );
};

export default DynamicTable;